import React, { useState, useEffect } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { ListSubheader } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import { setState, reset } from "../centralAdminSlice";

const MultiSelectLineItemRecordDelete = (props) => {
  const dispatch = useDispatch();
  const customerData = props?.LineItem;
  const LineItemList = customerData?.map((item) => item.lineItemNo);
  const [LineItem, setLineItem] = useState([]);
  const [PreviousSelected, setPreviousSelected] = useState([]);
  const [displayItem, setDisplayItem] = React.useState(customerData.length - 1);
  const [searchText, setSearchText] = React.useState("");
  const [namesData, setNamesData] = React.useState([]);
  const textInput = React.useRef(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const state = useSelector((store) => store.centralAdmin);

  const { selectedDataLineItemsDelete } = state;

  const handleChange = (e, name) => {
    let items = [...LineItem];

    if (e.target.checked) items.push(name);
    else {
      var index = items.indexOf(name);
      items.splice(index, 1);
    }
    setLineItem(items);                         
    let itemcount = items.length;
    setDisplayItem(itemcount - 1);
    if (itemcount == 0) setSelectAll(false);
    if (itemcount == LineItemList.length) setSelectAll(true);
    else setSelectAll(false);
  };

  useEffect(() => {
    // Clear search text value
    setNamesData(LineItemList);
  }, [customerData]);

  const handleDelete = (e, value) => {
    e.preventDefault();
    setSelectAll(false);
    setLineItem(LineItem.filter((name) => name !== value));
  };

  useEffect(() => {
    let item = [...namesData];
    item = item.filter((name) => !LineItem.includes(name));
    if(item.length == 0){
        setSelectAll(true);
    }else{
        setSelectAll(false);
    }
  }, [namesData]);

  const handleInputChange = (value) => {
    setSearchText(value);
  };

  const handleSelectAll = () => {
    if (!selectAll) {
      if (searchText) {
        let val = LineItemList.filter((name) =>
          name.toLowerCase().includes(searchText.toLowerCase())
        );
        let item = [...LineItem, ...val];
        const distinctArray = [...new Set(item)];
        setLineItem(distinctArray);
        let itemcount = distinctArray.length - 1;
        setDisplayItem(itemcount);
      } else {
        setLineItem(LineItemList);
        let itemcount = LineItemList.length - 1;
        setDisplayItem(itemcount);
      }
    } else {
      if (searchText) {
        let val = LineItemList.filter((name) =>
          name.toLowerCase().includes(searchText.toLowerCase())
        );
        let item = [...LineItem];
        item = item.filter((name) => !val.includes(name));
        const distinctArray = [...new Set(item)];
        setLineItem(distinctArray);
        let itemcount = distinctArray.length - 1;
        setDisplayItem(itemcount);
      } else {
        setLineItem([]);
      }
    }
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    //use a debounce to delay the search input key entry
    const delayDebounceFn = setTimeout(() => {
      if (searchText) {
        //filter options state using search text provided
        setNamesData((prevVal) => {
          let val = LineItemList.filter((name) => name.includes(searchText));

          return val;
        });
      } else {
        setSearchText();
        setNamesData(LineItemList);
      }

      //set focus on search text input field on load. setTimeOut is added as textInput is not immediately available
      setTimeout(() => {
        if (textInput.current) textInput.current.focus();
      }, 100);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  const getCustomerIdsFromNames = (LineItems) => {
    const customerIds = LineItems.map((name) => {
      const customer = customerData.find((option) => option.LineItem === name);
      return customer ? customer.LineItem : null;
    });
    return customerIds.filter((id) => id !== null);
  };

  useEffect(() => {
    if (LineItem.length > 0) {
      dispatch(setState("selectedDataLineItemsDelete", LineItem));
      dispatch(setState("clearIVDValues", false));
      const areMatching =
        LineItem.length === PreviousSelected.length &&
        LineItem.every((val, index) => val === PreviousSelected[index]);
      if (!areMatching) {
        dispatch(reset("OnLineItemChangeDelete"));
        setPreviousSelected(LineItem);
      }
    } else {
      dispatch(setState("selectedDataLineItemsDelete", []));
      dispatch(reset("OnLineItemChangeDelete"));
    }
  }, [LineItem]);

  useEffect(() => {
    if (selectedDataLineItemsDelete.length === 0) {
      setLineItem([]);
      setSelectAll(false);
    }
  }, [selectedDataLineItemsDelete]);

  return (
    <div>
      <FormControl>
        <InputLabel>Line Item Number</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          sx={{ width: 400 }}
          value={LineItem}
          size="small"
          input={<OutlinedInput label="Line Item Number" />}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }} MenuProps>
              {selected.length > 1 ? (
                <>
                  <Chip
                    label={selected[0]}
                    clickable
                    sx={{
                      bgcolor: "darkred.light",
                      color: "white.main",
                      textTransform: "none",
                      mt: 1,
                      mr: 2,
                      "&:hover": {
                        bgcolor: "darkred.main",
                      },
                    }}
                    variant="contained"
                    deleteIcon={
                      <CancelIcon
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                      />
                    }
                    onDelete={(e) => handleDelete(e, selected[0])}
                  />
                  <Box sx={{ mt: 1, mr: 2 }}>+ {selected.length - 1}</Box>
                </>
              ) : (
                selected.map((value, index) => (
                  <Chip
                    key={index}
                    label={value}
                    clickable
                    sx={{
                      bgcolor: "darkred.light",
                      color: "white.main",
                      textTransform: "none",
                      mt: 1,
                      mr: 2,
                      "&:hover": {
                        bgcolor: "darkred.main",
                      },
                    }}
                    variant="contained"
                    deleteIcon={
                      <CancelIcon
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                      />
                    }
                    onDelete={(e) => handleDelete(e, value)}
                  />
                ))
              )}
            </Box>
          )}
        >
          <MenuItem onClick={handleSelectAll}>
            <Checkbox checked={selectAll} />
            <ListItemText primary="Select All" />
          </MenuItem>
          <ListSubheader>
            <TextField
              size="small"
              inputRef={textInput}
              placeholder=""
              value={searchText}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setSearchText("")}>
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onChange={(e) => handleInputChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          {namesData?.map((name, index) => (
            <MenuItem key={index + name} value={name}>
              {selectAll ? (
                <Checkbox onChange={(e) => handleChange(e, name)}
                checked={LineItem.some((o) => o === name)} />
              ) : (
                <Checkbox onChange={(e) => handleChange(e, name)}
                checked={LineItem.indexOf(name) > -1} />
              )}
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default MultiSelectLineItemRecordDelete;